/**
 * Store for default cookie options
 *
 * TODO(tyler): set override via API module/project setting
 * @module
 */
var actionTypes = require('../constants/action_types');

/**
 * @const
 * @type {number}
 */
var DAY_IN_SECONDS = 60 * 60 * 24;

/**
 * Must not exceed the maximum arguable for compliance (e.g., GDPR) reasons.
 * @const
 * @type {number}
 */
var DEFAULT_COOKIE_EXPIRATION = DAY_IN_SECONDS * 30 * 6; // 6 months
var DEFAULT_COOKIE_AUTO_REFRESH = true;

module.exports = {
  initialize: function() {
    this.__state = {
      currentDomain: null,
      defaultAgeSeconds: DEFAULT_COOKIE_EXPIRATION,
      autoRefresh: DEFAULT_COOKIE_AUTO_REFRESH,
    };

    this.on(actionTypes.SET_COOKIE_DOMAIN, this.__setCurrentDomain);
    this.on(actionTypes.SET_COOKIE_AGE, this.__setDefaultAge);
    this.on(actionTypes.SET_COOKIE_AUTO_REFRESH, this.__setAutoRefresh);
  },

  /**
   *
   * @returns {null|string}
   */
  getCurrentDomain: function(): null|string {
    return this.__state.currentDomain;
  },

  /**
   *
   * @returns {number}
   */
  getDefaultAgeInSeconds: function(): number {
    return this.__state.defaultAgeSeconds;
  },

  /**
   *
   * @returns {boolean}
   */
  getAutoRefresh: function(): boolean {
    return this.__state.autoRefresh;
  },

  /**
   *
   * @param {string} payload
   * @private
   */
  __setCurrentDomain: function(payload:string) {
    this.__state.currentDomain = payload;
    this.emitChange();
  },

  /**
   *
   * @param {number} payload
   * @private
   */
  __setDefaultAge: function(payload:number) {
    this.__state.defaultAgeSeconds = payload;
    this.emitChange();
  },

  /**
   *
   * @param {boolean} payload
   * @private
   */
  __setAutoRefresh: function(payload:boolean) {
    this.__state.autoRefresh = payload;
    this.emitChange();
  },
};
